import { simpleUserSerializerMap } from "lib/serializers/simpleUser";
import {
  buildSerializer,
  buildDeserializer,
  SerializeMap,
} from "lib/serializerUtils";

const integrationCredentialSerializeMap: SerializeMap<IntegrationCredential> = {
  billingSettingsId: "billing_settings_id",
  created: "created",
  createdBy: simpleUserSerializerMap,
  defaultTenant: "default_tenant",
  id: "id",
  ingestExternalDocuments: "ingest_external_documents",
  integrationBusinessesLastSyncedAt: "integration_businesses_last_synced_at",
  integrationDocumentsLastSyncedAt: "integration_documents_last_synced_at",
  isEnabled: "is_enabled",
  message: "message",
  organizationShortCode: "organization_short_code",
  organizationName: "organization_name",
  tenantBlob: "tenant_blob",
  type: "type",
};

const nestedObjectMap = {
  created_by: "createdBy",
};

export const serializeIntegrationCredential = buildSerializer(
  integrationCredentialSerializeMap,
  "integrationCredential",
  nestedObjectMap,
);
export const deserializeIntegrationCredential = buildDeserializer(
  integrationCredentialSerializeMap,
  "integrationCredential",
  nestedObjectMap,
);
